import React from 'react'
import PropTypes from 'prop-types'
import ReactAvatar from 'react-avatar'

import { get } from 'lodash'

import { users } from '../redux'

const Avatar = ({ user, size, onClick }) => (
    <button type="button" onClick={ onClick } style={ { backgroundColor: 'transparent', border: 0 } }>
        <ReactAvatar
            initials={ users.avatarInitials(user) }
            name={ users.fullName(user) }
            email={ get(user, 'email') }
            size={ size }
            style={ { verticalAlign: 'middle' } }
            textSizeRatio={ 2 }
            round
        />
    </button>
)

Avatar.propTypes = {
    user    : PropTypes.object,
    size    : PropTypes.number,
    onClick : PropTypes.func
}

Avatar.defaultProps = {
    size: 32
}

export default Avatar
